import { getWordMetadataList } from '../../../../services/WordMetadataService'
import { useEffect, useState } from 'react'
import * as Sentry from '@sentry/browser';
import { logSentryException } from '../../../../services/util';

export default function useWordMetadata({ word }) {

  const [wordMetadata, setWordMetadata] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {

    if (word) {
      getWordMetadataList([word]).then((list) => {
        if (list.length) {
          setWordMetadata(list[0])
          setLoading(false)
        } else {
          throw new Error(`GetWordMetadataList returned empty list for ${word}`);
        }
      }).catch((err) => {
        // some server fatal error
        setError(err)
        setLoading(false)
        // also send this error to sentry for monitoring
        logSentryException(new Error("Could not fetch word metadata: " + word));
      })
    }else{
      setLoading(false)
    }
  }, [word])

  return {
    wordMetadata,
    error,
    loading,
  }
}